import _toConsumableArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";

/**
 * Quote form field validation module
 * Provides individual field validators and a comprehensive form validation function
 */
import { PROVIDER_SOURCE } from '../../constants/quote';
/**
 * Global enumeration of all quote form field names
 * Ensures consistency and provides IDE autocomplete across the application
 */

export var QuoteFormFieldNames;

(function (QuoteFormFieldNames) {
  QuoteFormFieldNames["FirstName"] = "firstName";
  QuoteFormFieldNames["LastName"] = "lastName";
  QuoteFormFieldNames["Email"] = "email";
  QuoteFormFieldNames["Phone"] = "phone";
  QuoteFormFieldNames["Country"] = "country";
  QuoteFormFieldNames["BusinessType"] = "businessType";
  QuoteFormFieldNames["CompanyName"] = "companyName";
  QuoteFormFieldNames["BusinessCountry"] = "businessCountry";
  QuoteFormFieldNames["BusinessAddress"] = "businessAddress";
  QuoteFormFieldNames["BusinessCity"] = "businessCity";
  QuoteFormFieldNames["BusinessPostcode"] = "businessPostcode";
  QuoteFormFieldNames["BusinessActivity"] = "businessActivity";
  QuoteFormFieldNames["OtherBusinessActivity"] = "otherBusinessActivity";
  QuoteFormFieldNames["PolicyType"] = "policyType";
  QuoteFormFieldNames["Turnover"] = "turnover";
  QuoteFormFieldNames["IncomeSplitUK"] = "incomeSplit.UK";
  QuoteFormFieldNames["IncomeSplitEU"] = "incomeSplit.EU";
  QuoteFormFieldNames["IncomeSplitUSA"] = "incomeSplit.USA";
  QuoteFormFieldNames["IncomeSplitROW"] = "incomeSplit.ROW";
  QuoteFormFieldNames["CoverProfessionalIndemnity"] = "covers.PROFESSIONAL_INDEMNITY";
  QuoteFormFieldNames["CoverPublicLiability"] = "covers.PUBLIC_LIABILITY";
  QuoteFormFieldNames["CoverEmployersLiability"] = "covers.EMPLOYERS_LIABILITY";
  QuoteFormFieldNames["Employees"] = "employees";
  QuoteFormFieldNames["ManualEmployees"] = "elSize.manualEmployees";
  QuoteFormFieldNames["ClericalEmployees"] = "elSize.clericalEmployees";
  QuoteFormFieldNames["PolicyStartDate"] = "policyStartDate";
  QuoteFormFieldNames["DeclarationQuestions"] = "declarationQuestions";
  QuoteFormFieldNames["Claims"] = "claims";
})(QuoteFormFieldNames || (QuoteFormFieldNames = {}));

/**
 * Personal Details - First Name
 */
export var checkQuoteFirstNameField = function checkQuoteFirstNameField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.FirstName)) {
    return null;
  }

  if (!value || typeof value !== 'string' || value.trim() === '') {
    return {
      key: QuoteFormFieldNames.FirstName,
      message: 'First name is required'
    };
  }

  return null;
};
/**
 * Personal Details - Last Name
 */

export var checkQuoteLastNameField = function checkQuoteLastNameField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.LastName)) {
    return null;
  }

  if (!value || typeof value !== 'string' || value.trim() === '') {
    return {
      key: QuoteFormFieldNames.LastName,
      message: 'Last name is required'
    };
  }

  return null;
};
/**
 * Personal Details - Email
 */

export var checkQuoteEmailField = function checkQuoteEmailField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.Email)) {
    return null;
  }

  if (!value || typeof value !== 'string' || value.trim() === '') {
    return {
      key: QuoteFormFieldNames.Email,
      message: 'Email is required'
    };
  } // Basic email format validation


  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(value)) {
    return {
      key: QuoteFormFieldNames.Email,
      message: 'Please enter a valid email address'
    };
  }

  return null;
};
/**
 * Personal Details - Phone
 */

export var checkQuotePhoneField = function checkQuotePhoneField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.Phone)) {
    return null;
  }

  if (!value || typeof value !== 'string' || value.trim() === '') {
    return {
      key: QuoteFormFieldNames.Phone,
      message: 'Phone number is required'
    };
  }

  return null;
};
/**
 * Personal Details - Country
 */

export var checkQuoteCountryField = function checkQuoteCountryField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.Country)) {
    return null;
  }

  if (!value || typeof value !== 'string' || value.trim() === '') {
    return {
      key: QuoteFormFieldNames.Country,
      message: 'Country is required'
    };
  }

  return null;
};
/**
 * Business Type
 */

export var checkQuoteBusinessTypeField = function checkQuoteBusinessTypeField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.BusinessType)) {
    return null;
  }

  if (!value || typeof value !== 'string' || value.trim() === '') {
    return {
      key: QuoteFormFieldNames.BusinessType,
      message: 'Business type is required'
    };
  }

  return null;
};
/**
 * Company Name / Trading Name
 */

export var checkQuoteCompanyNameField = function checkQuoteCompanyNameField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.CompanyName)) {
    return null;
  }

  if (!value || typeof value !== 'string' || value.trim() === '') {
    return {
      key: QuoteFormFieldNames.CompanyName,
      message: 'Company name is required'
    };
  }

  return null;
};
/**
 * Business Country
 */

export var checkQuoteBusinessCountryField = function checkQuoteBusinessCountryField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.BusinessCountry)) {
    return null;
  }

  if (!value || typeof value !== 'string' || value.trim() === '') {
    return {
      key: QuoteFormFieldNames.BusinessCountry,
      message: 'Business country is required'
    };
  }

  return null;
};
/**
 * Street address
 */

export var checkQuoteBusinessAddressField = function checkQuoteBusinessAddressField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.BusinessAddress)) {
    return null;
  }

  if (!value || typeof value !== 'string' || value.trim() === '') {
    return {
      key: QuoteFormFieldNames.BusinessAddress,
      message: 'Street address is required'
    };
  }

  return null;
};
/**
 * Business City
 */

export var checkQuoteBusinessCityField = function checkQuoteBusinessCityField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.BusinessCity)) {
    return null;
  }

  if (!value || typeof value !== 'string' || value.trim() === '') {
    return {
      key: QuoteFormFieldNames.BusinessCity,
      message: 'City is required'
    };
  }

  return null;
};
/**
 * Business Postcode
 */

export var checkQuoteBusinessPostcodeField = function checkQuoteBusinessPostcodeField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.BusinessPostcode)) {
    return null;
  }

  if (!value || typeof value !== 'string' || value.trim() === '') {
    return {
      key: QuoteFormFieldNames.BusinessPostcode,
      message: 'Postcode is required'
    };
  }

  return null;
};
/**
 * Business Activity
 */

export var checkQuoteBusinessActivityField = function checkQuoteBusinessActivityField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.BusinessActivity)) {
    return null;
  }

  if (!value || typeof value !== 'string' || value.trim() === '') {
    return {
      key: QuoteFormFieldNames.BusinessActivity,
      message: 'Business activity is required'
    };
  }

  return null;
};
/**
 * Policy Type
 */

export var checkQuotePolicyTypeField = function checkQuotePolicyTypeField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.PolicyType)) {
    return null;
  }

  if (!value || typeof value !== 'string' || value.trim() === '') {
    return {
      key: QuoteFormFieldNames.PolicyType,
      message: 'Policy type is required'
    };
  }

  return null;
};
/**
 * Estimated Turnover / Income
 */

export var checkQuoteTurnoverField = function checkQuoteTurnoverField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.Turnover)) {
    return null;
  }

  if (value === null || value === undefined || value === '') {
    return {
      key: QuoteFormFieldNames.Turnover,
      message: 'Estimated turnover is required'
    };
  }

  if (typeof value === 'number') {
    if (value <= 0) {
      return {
        key: QuoteFormFieldNames.Turnover,
        message: 'Estimated turnover must be greater than 0'
      };
    }
  }

  return null;
};
/**
 * Income Split - UK
 */

export var checkQuoteIncomeSplitUKField = function checkQuoteIncomeSplitUKField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.IncomeSplitUK)) {
    return null;
  }

  if (value === null || value === undefined || value === '') {
    return {
      key: QuoteFormFieldNames.IncomeSplitUK,
      message: 'UK income percentage is required'
    };
  }

  if (typeof value === 'number') {
    if (value < 0 || value > 100) {
      return {
        key: QuoteFormFieldNames.IncomeSplitUK,
        message: 'UK income percentage must be between 0 and 100'
      };
    }
  }

  return null;
};
/**
 * Income Split - EU
 */

export var checkQuoteIncomeSplitEUField = function checkQuoteIncomeSplitEUField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.IncomeSplitEU)) {
    return null;
  }

  if (value === null || value === undefined || value === '') {
    return {
      key: QuoteFormFieldNames.IncomeSplitEU,
      message: 'EU income percentage is required'
    };
  }

  if (typeof value === 'number') {
    if (value < 0 || value > 100) {
      return {
        key: QuoteFormFieldNames.IncomeSplitEU,
        message: 'EU income percentage must be between 0 and 100'
      };
    }
  }

  return null;
};
/**
 * Income Split - USA
 */

export var checkQuoteIncomeSplitUSAField = function checkQuoteIncomeSplitUSAField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.IncomeSplitUSA)) {
    return null;
  }

  if (value === null || value === undefined || value === '') {
    return {
      key: QuoteFormFieldNames.IncomeSplitUSA,
      message: 'USA income percentage is required'
    };
  }

  if (typeof value === 'number') {
    if (value < 0 || value > 100) {
      return {
        key: QuoteFormFieldNames.IncomeSplitUSA,
        message: 'USA income percentage must be between 0 and 100'
      };
    }
  }

  return null;
};
/**
 * Income Split - Rest of World (ROW)
 */

export var checkQuoteIncomeSplitROWField = function checkQuoteIncomeSplitROWField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.IncomeSplitROW)) {
    return null;
  }

  if (value === null || value === undefined || value === '') {
    return {
      key: QuoteFormFieldNames.IncomeSplitROW,
      message: 'Rest of World income percentage is required'
    };
  }

  if (typeof value === 'number') {
    if (value < 0 || value > 100) {
      return {
        key: QuoteFormFieldNames.IncomeSplitROW,
        message: 'Rest of World income percentage must be between 0 and 100'
      };
    }
  }

  return null;
};
/**
 * Number of Employees (conditional - required when Employers Liability is selected)
 */

export var checkQuoteEmployeesField = function checkQuoteEmployeesField(value, isEmployersLiabilityRequired) {
  var skipFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.Employees)) {
    return null;
  }

  if (isEmployersLiabilityRequired) {
    if (value === null || value === undefined || value === '') {
      return {
        key: QuoteFormFieldNames.Employees,
        message: 'Number of employees is required'
      };
    }

    if (typeof value === 'number' && value <= 0) {
      return {
        key: QuoteFormFieldNames.Employees,
        message: 'Number of employees must be greater than 0'
      };
    }
  }

  return null;
};
/**
 * Manual Employees (breakdown of employees)
 */

export var checkQuoteManualEmployeesField = function checkQuoteManualEmployeesField(value, employees) {
  var skipFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.ManualEmployees)) {
    return null;
  }

  if (employees === null || employees === undefined) {
    return null;
  }

  if (value === null || value === undefined || value === '') {
    return {
      key: QuoteFormFieldNames.ManualEmployees,
      message: 'Manual employees count is required'
    };
  }

  if (typeof value === 'number' && value < 0) {
    return {
      key: QuoteFormFieldNames.ManualEmployees,
      message: 'Manual employees count cannot be negative'
    };
  }

  return null;
};
/**
 * Clerical Employees (breakdown of employees)
 */

export var checkQuoteClericalEmployeesField = function checkQuoteClericalEmployeesField(value, employees) {
  var skipFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.ClericalEmployees)) {
    return null;
  }

  if (employees === null || employees === undefined) {
    return null;
  }

  if (value === null || value === undefined || value === '') {
    return {
      key: QuoteFormFieldNames.ClericalEmployees,
      message: 'Clerical employees count is required'
    };
  }

  if (typeof value === 'number' && value < 0) {
    return {
      key: QuoteFormFieldNames.ClericalEmployees,
      message: 'Clerical employees count cannot be negative'
    };
  }

  return null;
};
/**
 * Policy Start Date
 */

export var checkQuotePolicyStartDateField = function checkQuotePolicyStartDateField(value) {
  var skipFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.PolicyStartDate)) {
    return null;
  }

  if (!value) {
    return {
      key: QuoteFormFieldNames.PolicyStartDate,
      message: 'Policy start date is required'
    };
  } // Validate date format


  var dateValue = new Date(value);

  if (isNaN(dateValue.getTime())) {
    return {
      key: QuoteFormFieldNames.PolicyStartDate,
      message: 'Please enter a valid date'
    };
  }

  return null;
};
/**
 * Claims Validation
 * Validates hasClaims and claimList fields
 * - If hasClaims is true, claimList must have at least 1 item
 * - Each item in claimList must have required fields: amount and date
 */

export var checkQuoteClaimsField = function checkQuoteClaimsField(hasClaims, claimList) {
  var skipFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var errors = []; // Skip if Claims field is in skipFields

  if (skipFields !== null && skipFields !== void 0 && skipFields.includes(QuoteFormFieldNames.Claims)) {
    return errors;
  } // If hasClaims is true, validate claimList


  if (hasClaims === true) {
    // Check if claimList exists and has at least 1 item
    if (!claimList || !Array.isArray(claimList) || claimList.length < 1) {
      errors.push({
        key: QuoteFormFieldNames.Claims,
        message: 'At least one claim is required when claims exist'
      });
      return errors;
    } // Validate each claim item


    claimList.forEach(function (claim, index) {
      // Check amount (required)
      if (claim.amount === null || claim.amount === undefined || claim.amount === '') {
        errors.push({
          key: "".concat(QuoteFormFieldNames.Claims, "[").concat(index, "].amount"),
          message: "Claim ".concat(index + 1, ": Amount is required")
        });
      } // Check date (required)


      if (!claim.date) {
        errors.push({
          key: "".concat(QuoteFormFieldNames.Claims, "[").concat(index, "].date"),
          message: "Claim ".concat(index + 1, ": Date is required")
        });
      } else {
        // Validate date format
        var dateValue = new Date(claim.date);

        if (isNaN(dateValue.getTime())) {
          errors.push({
            key: "".concat(QuoteFormFieldNames.Claims, "[").concat(index, "].date"),
            message: "Claim ".concat(index + 1, ": Please enter a valid date")
          });
        }
      }
    });
  }

  return errors;
};
/**
 * Main validation function - checks all required fields based on provider code
 * @param formData - The complete form data object
 * @param config - Configuration object containing providerCode and skipFields
 * @returns Array of validation errors (empty array if all fields are valid)
 */

export var checkAllQuoteFormFields = function checkAllQuoteFormFields(formData, config) {
  var providerCode = config.providerCode,
      skipFields = config.skipFields; // Route to provider-specific validation

  var validationErrors = []; // Contact info

  var firstNameError = checkQuoteFirstNameField(formData === null || formData === void 0 ? void 0 : formData.firstName, skipFields);
  if (firstNameError) validationErrors.push(firstNameError);
  var lastNameError = checkQuoteLastNameField(formData === null || formData === void 0 ? void 0 : formData.lastName, skipFields);
  if (lastNameError) validationErrors.push(lastNameError);
  var emailError = checkQuoteEmailField(formData === null || formData === void 0 ? void 0 : formData.email, skipFields);
  if (emailError) validationErrors.push(emailError);
  var phoneError = checkQuotePhoneField(formData === null || formData === void 0 ? void 0 : formData.phone, skipFields);
  if (phoneError) validationErrors.push(phoneError);
  var countryError = checkQuoteCountryField(formData === null || formData === void 0 ? void 0 : formData.country, skipFields);
  if (countryError) validationErrors.push(countryError); // Business type

  var businessTypeError = checkQuoteBusinessTypeField(formData === null || formData === void 0 ? void 0 : formData.businessType, skipFields);
  if (businessTypeError) validationErrors.push(businessTypeError); // Company address

  var companyNameError = checkQuoteCompanyNameField(formData === null || formData === void 0 ? void 0 : formData.companyName, skipFields);
  if (companyNameError) validationErrors.push(companyNameError);
  var businessCountryError = checkQuoteBusinessCountryField(formData === null || formData === void 0 ? void 0 : formData.businessCountry, skipFields);
  if (businessCountryError) validationErrors.push(businessCountryError);
  var businessAddressError = checkQuoteBusinessAddressField(formData === null || formData === void 0 ? void 0 : formData.businessAddress, skipFields);
  if (businessAddressError) validationErrors.push(businessAddressError);
  var businessCityError = checkQuoteBusinessCityField(formData === null || formData === void 0 ? void 0 : formData.businessCity, skipFields);
  if (businessCityError) validationErrors.push(businessCityError);
  var businessPostcodeError = checkQuoteBusinessPostcodeField(formData === null || formData === void 0 ? void 0 : formData.businessPostcode, skipFields);
  if (businessPostcodeError) validationErrors.push(businessPostcodeError);
  /**
   * Business Activity
   */

  if (![PROVIDER_SOURCE().GREATEAMERICAN.value].includes(config === null || config === void 0 ? void 0 : config.providerCode)) {
    var businessActivityError = checkQuoteBusinessActivityField(formData === null || formData === void 0 ? void 0 : formData.businessActivity, skipFields);
    if (businessActivityError) validationErrors.push(businessActivityError);
  }
  /**
   * Policy Type
   */


  if ([PROVIDER_SOURCE().ACCELERANT.value].includes(config === null || config === void 0 ? void 0 : config.providerCode)) {
    var policyTypeError = checkQuotePolicyTypeField(formData === null || formData === void 0 ? void 0 : formData.policyType, skipFields);
    if (policyTypeError) validationErrors.push(policyTypeError);
  }
  /**
   * Turnover
   */


  if ([PROVIDER_SOURCE().ACCELERANT.value].includes(config === null || config === void 0 ? void 0 : config.providerCode)) {
    var turnoverError = checkQuoteTurnoverField((formData === null || formData === void 0 ? void 0 : formData.turnover) || (formData === null || formData === void 0 ? void 0 : formData.turnoverRaw), skipFields);
    if (turnoverError) validationErrors.push(turnoverError);
  }
  /**
   * Income Split
   */


  if (formData !== null && formData !== void 0 && formData.incomeSplit) {
    var incomeSplitUKError = checkQuoteIncomeSplitUKField(formData.incomeSplit.UK, skipFields);
    if (incomeSplitUKError) validationErrors.push(incomeSplitUKError);
    var incomeSplitEUError = checkQuoteIncomeSplitEUField(formData.incomeSplit.EU, skipFields);
    if (incomeSplitEUError) validationErrors.push(incomeSplitEUError);
    var incomeSplitUSAError = checkQuoteIncomeSplitUSAField(formData.incomeSplit.USA, skipFields);
    if (incomeSplitUSAError) validationErrors.push(incomeSplitUSAError);
    var incomeSplitROWError = checkQuoteIncomeSplitROWField(formData.incomeSplit.ROW, skipFields);
    if (incomeSplitROWError) validationErrors.push(incomeSplitROWError);
  }
  /**
   * Claims
   */


  if ([PROVIDER_SOURCE().ACCELERANT.value].includes(config === null || config === void 0 ? void 0 : config.providerCode)) {
    var claimsErrors = checkQuoteClaimsField(formData === null || formData === void 0 ? void 0 : formData.hasClaims, formData === null || formData === void 0 ? void 0 : formData.claimList, skipFields);
    if (claimsErrors.length > 0) validationErrors.push.apply(validationErrors, _toConsumableArray(claimsErrors));
  }
  /**
   * Employees
   */
  // const isEmployersLiabilityRequired = !!formData?.covers?.EMPLOYERS_LIABILITY;
  // const employeesError = checkQuoteEmployeesField(formData?.employees, isEmployersLiabilityRequired, skipFields);
  // if (employeesError) validationErrors.push(employeesError);
  // if (formData?.elSize) {
  //   const manualEmployeesError = checkQuoteManualEmployeesField(formData.elSize.manualEmployees, formData.employees, skipFields);
  //   if (manualEmployeesError) validationErrors.push(manualEmployeesError);
  //   const clericalEmployeesError = checkQuoteClericalEmployeesField(formData.elSize.clericalEmployees, formData.employees, skipFields);
  //   if (clericalEmployeesError) validationErrors.push(clericalEmployeesError);
  // }

  /**
   * Policy Start Date Validation
   */


  var policyStartDateError = checkQuotePolicyStartDateField(formData === null || formData === void 0 ? void 0 : formData.projectPeriodStart, skipFields);
  if (policyStartDateError) validationErrors.push(policyStartDateError);
  return validationErrors;
};
/**
 * Helper function to check if form is valid
 * @param formData - The complete form data object
 * @param config - Configuration object containing providerCode and skipFields
 * @returns Boolean indicating if form is valid
 */

export var isQuoteFormValid = function isQuoteFormValid(formData, config) {
  var errors = checkAllQuoteFormFields(formData, {
    providerCode: config.providerCode,
    skipFields: config.skipFields || []
  });
  return errors.length === 0;
};
/**
 * Helper function to get validation errors as a map (key -> message)
 * @param formData - The complete form data object
 * @param config - Configuration object containing providerCode and skipFields
 * @returns Object mapping field keys to error messages
 */

export var getQuoteFormErrorsMap = function getQuoteFormErrorsMap(formData, config) {
  var errors = checkAllQuoteFormFields(formData, {
    providerCode: config.providerCode,
    skipFields: config.skipFields || []
  });
  var errorMap = {};
  errors.forEach(function (error) {
    if (!errorMap[error.key]) {
      errorMap[error.key] = error.message;
    }
  });
  return errorMap;
};